import { render } from "./Footer.vue?vue&type=template&id=46dbfc8f&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=46dbfc8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4c70acdb4c746897c15f9d0e9400da56/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dbfc8f"]])

export default __exports__